import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const StoreCode = ({ codeType }) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search); 
        const code = params.get(codeType);

        if (code) {
            localStorage.setItem(codeType, code); 
            console.log(`${codeType} saved:`, code);
        } else {
            alert(`No ${codeType} found in the URL`);
        }

        navigate('/signup'); 
    }, [location, navigate, codeType]);

    return null; // No UI needed
};

export default StoreCode;
